module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2NlMTEyNCIgZD0iTTIxNS4wNCAwaDgxLjkydjUxMmgtODEuOTJ6Ii8+CiAgPHBhdGggZmlsbD0iI2NlMTEyNCIgZD0iTTAgMjE1LjA0aDUxMnY4MS45MkgweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gb-eng.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gb-eng.svg
// module chunks = 0